// src/pages/Home.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import mark from "../assets/teamkitty-mark.svg";
import { trackEvent } from "../utils/analytics";

export default function Home() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen tk-gradient-bg text-[#0B1C2C]">
      <section className="mx-auto grid min-h-screen max-w-6xl items-center gap-10 px-6 py-12 md:grid-cols-[1.1fr_.9fr]">
        <div className="text-center md:text-left">
          {/* HTML logo/wordmark - no SVG text, so it will not clip */}
          <div className="mb-8 flex flex-col items-center gap-4 md:flex-row md:items-center md:gap-5">
            <img
              src={mark}
              alt="TeamKitty logo mark"
              className="h-24 w-24 rounded-2xl shadow-xl md:h-28 md:w-28"
            />

            <div className="min-w-0">
              <div className="tk-wordmark text-4xl leading-none md:text-5xl">
                <span className="tk-wordmark-team">team</span>
                <span className="tk-wordmark-kitty">kitty</span>
                <span className="tk-wordmark-io">.io</span>
              </div>

              <div className="mt-4 flex flex-wrap justify-center gap-x-3 gap-y-2 text-[11px] font-black uppercase tracking-[0.35em] text-[#0B1C2C] md:justify-start md:text-xs">
                <span>Your team.</span>
                <span className="text-slate-400">|</span>
                <span className="text-[#F59E0B]">Your card.</span>
                <span className="text-slate-400">|</span>
                <span>Your community.</span>
              </div>
            </div>
          </div>

          <div className="mb-5 inline-flex rounded-full bg-white px-4 py-2 text-sm font-bold text-[#0B1C2C] shadow-sm ring-1 ring-[#0B1C2C]/10">
            Sporty team payments, balances and kitty tracking
          </div>

          <h1 className="max-w-3xl text-4xl font-black tracking-tight md:text-6xl">
            Manage your team kitty without messy spreadsheets.
          </h1>

          <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-700">
            TeamKitty helps sports teams and social groups track member balances,
            top-ups, purchases, fines and team activity in one clean, simple place.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center md:justify-start">
            <button
              onClick={() => {
                trackEvent("cta_login_click", { cta_location: "home_hero" });
                navigate("/login");
              }}
              className="rounded-xl bg-[#0B1C2C] px-8 py-3 font-bold text-white shadow-md transition hover:bg-[#13293D]"
            >
              Login
            </button>
            <button
              onClick={() => {
                trackEvent("cta_register_click", { cta_location: "home_hero" });
                navigate("/register");
              }}
              className="rounded-xl bg-[#F59E0B] px-8 py-3 font-bold text-[#0B1C2C] shadow-md transition hover:bg-[#FFB52E]"
            >
              Register
            </button>
          </div>

          <p className="mt-8 text-sm text-slate-600">
            Questions or partnership ideas?{" "}
            <a href="mailto:contact@teamkitty.io" className="font-bold text-[#0B1C2C] underline decoration-[#F59E0B] decoration-2 underline-offset-4">
              contact@teamkitty.io
            </a>
          </p>
        </div>

        <div className="mx-auto w-full max-w-sm rounded-[2rem] bg-white p-6 tk-sport-card">
          <div className="rounded-[1.5rem] bg-[#0B1C2C] p-6 text-white">
            <img src={mark} alt="" className="mb-8 h-20 w-20 rounded-2xl shadow-xl" />
            <p className="text-sm font-bold uppercase tracking-[0.35em] text-[#F59E0B]">Team Kitty</p>
            <h2 className="mt-3 text-3xl font-black">Shared balance</h2>
            <div className="mt-8 rounded-2xl bg-white/10 p-4">
              <div className="text-sm text-slate-300">Team funds</div>
              <div className="mt-1 text-4xl font-black">$540</div>
            </div>
            <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
              <div className="rounded-2xl bg-white/10 p-4">
                <div className="text-slate-300">Top-ups</div>
                <div className="font-bold text-[#F59E0B]">12</div>
              </div>
              <div className="rounded-2xl bg-white/10 p-4">
                <div className="text-slate-300">Members</div>
                <div className="font-bold text-[#F59E0B]">18</div>
              </div>
            </div>
          </div>
          
        </div>
        <div
  style={{
    marginTop: "40px",
    textAlign: "center",
    fontSize: "13px",
    color: "#9ca3af",
  }}
>
  <a href="/privacy" style={{ marginRight: "16px", color: "#9ca3af" }}>
    Privacy Policy
  </a>

  <a href="/terms" style={{ marginRight: "16px", color: "#9ca3af" }}>
    Terms
  </a>

  <a href="/cookies" style={{ color: "#9ca3af" }}>
    Cookies
  </a>
</div>
      </section>
    </main>
    
  );
}
